module.exports = __webpack_public_path__ + "static/media/bgPrivateGroup.ac473273.png";